<div class="form-panel-container">
    @if (attributeValues) {
        <div class="drop-list-container">
            <div
                id="AttributeValues"
                cdkDropList
                [cdkDropListData]="attributeValues"
                class="drop-list"
                (cdkDropListDropped)="drop($event)"
                [cdkDropListDisabled]="enumHelper.areEquals(FormMode, _context.mode, FormMode.Reading)">
                @for (item of attributeValues; track item) {
                    @if (item.isDeleted === false) {
                        <div class="attribute-list-value drop-item" cdkDrag cdkDragPreview>
                            @if (enumHelper.areNotEquals(FormMode, _context.mode, FormMode.Reading)) {
                                <fa-icon [icon]="faGripLinesVertical" class="fa-lg drag-handle" cdkDragHandle></fa-icon>
                            }
                            <span class="label">{{ item.data.id ? item.data.id + ' - ' : '' }}{{ item.data.name }}</span>
                            @if (enumHelper.areNotEquals(FormMode, _context.mode, FormMode.Reading)) {
                                <fa-icon [icon]="faDelete" class="fa-lg drag-item-action" (click)="onRemoveAttributeValue(item.data.name)"></fa-icon>
                                <fa-icon [icon]="faEdit" class="fa-lg drag-item-action" (click)="onEditAttributeValue(item.data.name)"></fa-icon>
                            }
                        </div>
                    }
                }
            </div>
        </div>
    }

    <div class="buttons-container">
        @if (enumHelper.areNotEquals(FormMode, _context.mode, FormMode.Reading)) {
            <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        }
        <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); onAttributeValuesExported()">Exporter</button>
        @if (enumHelper.areNotEquals(FormMode, _context.mode, FormMode.Reading)) {
            <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); fileToUpload.click()">Importer</button>
            <button mat-raised-button class="accent-button" (click)="onAddAttributeValue()">Ajouter une valeur</button>
            <button mat-raised-button class="accent-button" (click)="saveAttributeValues()">Enregistrer</button>
        }
        <input ng2FileSelect #fileToUpload class="file-to-upload" type="file" [uploader]="uploader" (change)="onFileSelected()" [hidden]="true" />
    </div>
</div>
